 <div *ngFor="let notice of notices">
  <div class="alert alert-{{notice.severity}}">
    {{notice.message}}
  </div>
</div>